module.exports = __webpack_public_path__ + "img/q8.280193d2.png";